<template>
    <el-container>
        <el-header>
            <commonheader :isNavShow='true'></commonheader>
        </el-header>

        <el-container class="el-container-master">
            <el-aside style="width:220px">
                <leftMenu></leftMenu>
            </el-aside>
            <el-main>
                <section class="flex">
                    <exit></exit>

                    <div class="content">
                        <div class="onlineTeachingCont">
                            <div class="onlineTeachingContRight">
                                <div class="onlineTeachingContPadding">
                                    <div class="onlineTeachingContTop">
                                        <div class="classTypesSelect">
                                            选择继续教育学年:
                                            <el-select v-model="year_value" placeholder="请选择" @change="yearChange">
                                                <el-option v-for="item in year" :key="item.year" :label="item.year" :value="item.year">
                                                </el-option>
                                            </el-select>
                                        </div>

                                        <div class="classTypesTab">
                                            <p v-for="(item, idx) in classTypesTabData" :key="idx"
                                                :class="{'active':activeIdx === idx}" @click="classTypesTabEvent(idx)">
                                                {{item.title}}</p>
                                        </div>

                                        <!--网授课已选课程-->
                                        <net-class v-show="this.activeIdx == 0"
                                            :netClassData='netClassData' :year_value='year_value' :year='year'></net-class>
                                       

                                        <!--面授课已选课程-->
                                        <div class="faceCourseAllCont" v-show="this.activeIdx == 1">

                                            <div class="selectedCourseBanner">
                                                <div class="selectedCourse">
                                                    <span>已选课程：3</span>
                                                    <span>已选学分：15.0</span>
                                                </div>

                                                <div class="learnTotalProcess">学习总进度：
                                                    <div class="processBarBox">
                                                        <span class="processBar"></span>
                                                        <span class="currentProcessBar"
                                                            :style="{width:processNumber}"></span>
                                                        <span>50%</span>
                                                    </div>
                                                </div>

                                            </div>

                                            <ul class="compulsoryCourseList">
                                                <li>
                                                    <div class="compulsoryCourseImg fl">
                                                        <img
                                                            src="https://img.baitongshiji.com/public/Statics/img/logo.png" />
                                                    </div>
                                                    <div class="compulsoryCourseImgInfor  fl">
                                                        <p class="compulsoryCourseImgTitle textCut">
                                                            必修课程药师工匠精神程药师工匠必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神精神
                                                        </p>
                                                        <p class="compulsoryCourseScore">
                                                            <span>学分：1.0</span><span>学习进度：10%</span></p>
                                                    </div>

                                                    <div class="studenInterest">
                                                        <span class="alreadyJoinBtn blueGradient"
                                                            @click="jumpVideoLearningPage()">继续学习</span>
                                                    </div>

                                                </li>
                                                <li>
                                                    <div class="compulsoryCourseImg fl">
                                                        <img
                                                            src="https://img.baitongshiji.com/public/Statics/img/logo.png" />
                                                    </div>
                                                    <div class="compulsoryCourseImgInfor  fl">
                                                        <p class="compulsoryCourseImgTitle textCut">
                                                            必修课程药师工匠精神程药师工匠必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神精神
                                                        </p>
                                                        <p class="compulsoryCourseScore">
                                                            <span>学分：1.0</span><span>学习进度：10%</span></p>
                                                    </div>
                                                    <div class="studenInterest">
                                                        <span class="alreadyJoinBtn blueGradient"
                                                            @click="jumpVideoLearningPage()">开始学习</span>
                                                    </div>

                                                </li>

                                                <li>
                                                    <div class="compulsoryCourseImg fl">
                                                        <img
                                                            src="https://img.baitongshiji.com/public/Statics/img/logo.png" />
                                                    </div>
                                                    <div class="compulsoryCourseImgInfor  fl">
                                                        <p class="compulsoryCourseImgTitle textCut">
                                                            必修课程药师工匠精神程药师工匠必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神必修课程药师工匠精神程药师工匠精神精神
                                                        </p>
                                                        <p class="compulsoryCourseScore">
                                                            <span>学分：1.0</span><span>学习进度：10%</span></p>
                                                    </div>
                                                    <div class="studenInterest">
                                                        <span class="alreadyJoinBtn blueGradient"
                                                            @click="jumpVideoLearningPage()">开始学习</span>
                                                    </div>

                                                </li>

                                            </ul>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                    <!-- <dialog :haveTitle="true"></dialog> -->

                </section>
            </el-main>
        </el-container>
    </el-container>

</template>

<script>

import Vue from 'vue'
import commonheader from '../../common/commonHeader.vue'
import leftMenu from "../../common/leftMenu.vue";
import exit from "../../common/exit.vue";
// import dialog from "../../common/dialog.vue";
import netClass from "./netClass.vue";


export default {
    name: "index",
    components: {
        commonheader,
        exit,
        leftMenu,
        // dialog,
        netClass
    },
    data () {
        return {
            year: [],
            year_value: 0,

            classTypesTabData: [
                {
                    'title': '网授课程'
                },
                {
                    'title': '面授课程'
                }
            ],
            activeIdx: 0,
            faceCourseAddress: [
                {
                    'address': '湖南中医药湖南中医药大学湖南中医药大学湖南中医药大学湖南中医药大学湖南中医药大学湖南中医药大学湖南中医药大学湖南中医药大学湖南中医药大学湖南中医药大学湖南中医药大学大学',
                    'teacher': '李老师'
                },

                {
                    'address': '湖南中医药大学',
                    'teacher': '李老师'
                },

                {
                    'address': '湖南中医药大学',
                    'teacher': '张张老师'
                },
                {
                    'address': '湖南中医药大学',
                    'teacher': '李老师'
                }
            ],

            processNumber: '400px',

            netClassData: {},
        };
    },
    mounted: function () {

        document.getElementsByTagName("html")[0].className = "my-page";
        this.getYear();
    },
    methods: {
        /**
         * 获取年份
         */
        getYear () {
            this.$store.dispatch('academic_year', {}).then((res) => {
                let currYear = new Date().getFullYear();
                if (this.$route.path == '/myCourseCopy') {
                    // res.data = res.data.filter(item => item != currYear);
                    res.data = res.data.filter(item => item.is_buxue == 1);
                }
                console.log(res.data)

                if (res.data.length) {
                    this.year_value = res.data[0].year;
                    this.year = res.data;
                    this.getMyCourse();
                }else{
                    this.netClassData = {};
                }
            })
        },
        /**
         * 获取我的课程
         * year  年份
         * type  教育类型： 1 网授 2 面授
         */
        getMyCourse () {
            let params = {
                year: this.year_value,
                type: this.activeIdx + 1
            }
            this.$store.dispatch('mycourses', params).then((res) => {
                this.netClassData = res.data;
                // res.data.courses = [];
                //course_type  课程类型 1 必修 2 选修
                // if (this.activeIdx + 1 == 1) {
                // this.netClassData = this.getTotalPro(res.data);
                // } else {
                // this.faceCourseList = res.data.courses;
                // }

            })
        },

        /**
         * 年份改变
         */
        yearChange () {
            this.getMyCourse();
        },

        classTypesTabEvent (idx) {
            if (idx == 1) {
                this.$message('暂未开放');
                return false;
            }
            this.activeIdx = idx
        },

        jumpVideoLearningPage () {
            this.$router.push('/videoLearning')
        },
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (min-width: 1399px) {
    .el-container-master {
        width: 1400px;
        margin: auto;
    }
}

.el-aside {
    background: #fff;
}

.el-main {
    padding: 0;
    background: #fff;
}

.content {
    padding: 47px 57px 0 86px;
    flex: 1;
    border-top: 10px solid #f8f8f8;
    border-left: 10px solid #f8f8f8;
}

/* .content {
  width:1400px;
  margin: 0 auto;
  padding-bottom:40px;
} */

.onlineTeachingContRight {
    /* margin: 10px 0; */
    background: #fff;
    /* box-shadow:0px 0px 15px 0px rgba(218,218,218,0.5); */
}

.onlineTeachingCont {
    overflow: hidden;
}

.onlineTeachingContPadding {
    /* padding:0px 50px 50px 50px; */
    background: #fff;
    border-radius: 4px;
}

.classTypesTab,
.onlineConfirmSignUpBtns {
    overflow: hidden;
    margin: 0 auto;
    text-align: center;
}
.classTypesTab > p {
    display: inline-block;
    margin: 0 35px;
    width: 110px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    color: #0173ff;
    font-size: 16px;
    letter-spacing: 2px;
    border: 1px solid #43affc;
    border-radius: 4px;
    cursor: pointer;
}

.onlineConfirmSignUpBtns {
    margin-top: 100px;
}
.onlineConfirmSignUpBtns > p {
    display: inline-block;
    margin: 0 35px;
    width: 140px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    font-size: 16px;
    letter-spacing: 2px;
    border: 1px solid #43affc;
    border-radius: 4px;
    cursor: pointer;
}

.classTypesTab > p.active {
    background-image: -webkit-linear-gradient(left, #4bb7fc, #0173ff);
    background-image: -o-linear-gradient(left, #4bb7fc, #0173ff);
    background-image: -ms-linear-gradient(left, #4bb7fc, #0173ff);
    background-image: linear-gradient(left, #4bb7fc, #0173ff);
    color: #fff;
    border: none;
}

.onlineTeachingContTop {
    position: relative;
}

.classTypesSelect {
    position: absolute;
    left: 0px;
    top: 0;
}
.classTypesSelect .el-select {
    width: 100px;
}

.selectedCourseBanner {
    height: 100px;
    margin-top: 60px;
    background: url("../../../assets/images/myCourseBg.png") no-repeat center;
    background-size: cover;
    padding: 20px 60px;
    box-sizing: border-box;
    color: #fff;
}

.selectedCourse {
}

.selectedCourse span {
    font-size: 18px;
    margin-right: 30px;
}

.processBarBox {
    display: inline-block;
    position: relative;
}

.processBar {
    display: inline-block;
    width: 600px;
    height: 5px;
    background: #fff;
    border-radius: 180px;
}

.processBarBox {
    position: relative;
}

.currentProcessBar {
    position: absolute;
    height: 5px;
    width: 100px;
    background-image: -webkit-linear-gradient(left, #4bb7fc, #0173ff);
    background-image: -o-linear-gradient(left, #4bb7fc, #0173ff);
    background-image: -ms-linear-gradient(left, #4bb7fc, #0173ff);
    background-image: linear-gradient(left, #4bb7fc, #0173ff);
    border-radius: 180px;
    top: 13px;
    left: 0;
    width: 100%;
    right: 0;
}

.compulsoryCourseList {
    /* margin:0 5px 0 10px; */
    margin-top: 30px;
}
.compulsoryCourseList li {
    padding: 10px;
    overflow: hidden;
    border-radius: 8px;
    margin-top: 20px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 0px 15px 0px rgba(218, 218, 218, 0.5);
    position: relative;
}
.compulsoryCourseImg img {
    width: 105px;
    height: 80px;
    display: block;
}

.compulsoryCourseImgInfor {
    max-width: 55%;
    margin-left: 15px;
}

.compulsoryCourseImgTitle {
    width: 100%;
    color: #333;
    font-weight: bold;
}
.compulsoryCourseImgTitle,
.compulsoryCourseScore {
    margin-top: 12px;
}
.compulsoryCourseScore {
}

.compulsoryCourseScore span {
    color: #999;
    font-size: 14px;
    margin-right: 30px;
}

.studenInterest {
    position: absolute;
    right: 10px;
    bottom: 20px;
    font-size: 14px;
}

.studenInterest span {
    display: inline-block;
    width: 82px;
    height: 26px;
    line-height: 26px;
    /* color:#0173FF; */
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    margin-right: 20px;
    border-top-left-radius: 12px;
    border-bottom-right-radius: 12px;
}

.continueselectCourseBtn {
    width: 290px;
    height: 40px;
    line-height: 40px;
    text-align: center;
    color: #0173ff;
    border: 1px solid #0173ff;
    border-radius: 4px;
    font-size: 16px;
    margin: 80px auto 0;
    cursor: pointer;
}

.learnTotalProcess {
    margin-top: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/my/myCourse/index.vue